import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'h3-cuboid-dimensions',
  templateUrl: './cuboid-dimensions.svg',
  styleUrls: ['./cuboid-dimensions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CuboidDimensionsComponent {}
